import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function BackButton({ to, label, onClick, testid = "back-btn", className = "" }) {
  const nav = useNavigate();
  const go = () => {
    if (onClick) return onClick();
    if ((window.history.state?.idx ?? 0) > 0) return nav(-1);
    return nav(to, { replace: true });
  };
  return (
    <button type="button" onClick={go} data-testid={testid}
      className={`no-print inline-flex items-center gap-1.5 rounded-md px-1.5 py-1 text-[13px] font-semibold text-[#283F91] transition-colors hover:bg-[#EAF4FF] dark:text-blue-300 dark:hover:bg-white/5 ${className}`}>
      <ArrowLeft size={14} />{label}
    </button>
  );
}
